import React, { useState, useEffect } from "react";

import axios from "axios";
import numeral from "numeral";

import { PdfDocument } from "../../components/PDF/CheckPdf";
// Components
import DynamicTable from "../../components/DynamicTable";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import { PDFDownloadLink } from '@react-pdf/renderer';
import CheckPrint from "./CheckPrint";

// Material UI Component
import {
	TextField,
	Grid,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
//cookies
import { get_cookies } from "../../components/Cookies/Cookies";
import { set } from "date-fns/esm";

const CheckTransactionHistory = () => {

	const [posts, setPosts] = useState(null);
	const [open, setOpen] = useState(false);
	const [headerDetailsP, setHeaderDetailsP] = useState([]);
	const [itemDetailsP, setItemDetailsP] = useState([]);
	const [pCheckNo, setPCheckNo] = useState("");
	const [dateRange, setDateRange] = useState({
		startDate: new Date("2022-02-01"),
		endDate: addDays(new Date(), 40),
	});
	const [showPrint, setHidePrint] = useState(false);
	const [printBtn, setPrintBtn] = useState(true);
	const useridNo = get_cookies('branchidno');

	const headers = {
		'Content-Type': 'multipart/form-data',
	};
	const refDataFilter = React.createRef();
	const onFetchedApi = () => refDataFilter.current.onFetchApi();

	// Data Fetching
	useEffect(() => {
		onFetchedApi();
	}, []);


	const toggle = () => setOpen(!open);

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};


	const printCheck = async (chkno, branchidno) => {

		const formData = new FormData();
		formData.append("chkno", chkno);
		formData.append("jc_u_idno", branchidno);
		await axios.post(process.env.REACT_APP_API_URL + 'print_check', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {

			//window.open("data:application/pdf," + res.data.pdf,"_blank"); 
			let pdfWindow = window.open("")
			pdfWindow.document.write(
				"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
				encodeURI(res.data.pdf) + "'></iframe>"
			)
			onFetchedApi(); //refresh to apply printed=yes status	//can be improved by just setting the state to true

		}).catch((error) => {
			// console.log(error.message);
		})
	}

	const HandleClick = (chkno, useridNo) => {
		setPCheckNo(chkno);
		get_checkpdf(chkno, useridNo);
	}
	const get_checkpdf = async (chkno, branchidno) => {
		const formData = new FormData();
		formData.append("chkno", chkno);
		formData.append("jc_u_idno", branchidno);
		await axios.post(process.env.REACT_APP_API_URL + 'print_check', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			setHeaderDetailsP(res.data.header_details);
			setItemDetailsP(res.data.item_details);
			setPrintBtn(false);
			setHidePrint(true);
		}).catch((error) => {
			// console.log(error.message);
		})
		// setHeaderDetailsP(res.data.header_details);
		// setItemDetailsP(res.data.item_details);
		// setPaymentP(res.data.paymentDetails);
		// setComputationDetailsP(res.data.computations_details);
		// setHidePrint(true);
	};


	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "reference",
			label: "Reference",
		},
		{
			name: "payto",
			label: "Pay To",
		},
		{
			name: "amount",
			label: "Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<div style={{ textAlign: "right" }}>{numeral(value).format('0,0.00')}</div>
					);
				}
			}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "printed",
			label: "Printed",
		},
		{
			name: "cleared",
			label: "Cleared",
		},
		{
			name: "allocation",
			label: "Allocation",
		},
		{
			name: "reference",
			label: "Action",
			options: {
				sort: false,
				filter: false,
				customBodyRenderLite: (dataIndex) => {
					let chkno = (posts || [])[dataIndex].reference;
					let checkstatus = (posts || [])[dataIndex].status;
					let printed = (posts || [])[dataIndex].printed;
					let cleared = (posts || [])[dataIndex].cleared;

					//return poretno + " " + allocateall;
					if (checkstatus === "Approved" && printed === "No") {
						return (
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
									<NavLink to={"/account/check-view/" + chkno + "/" + useridNo}> {/*Check View*/}
										<Button variant="contained" color="primary">
											View
										</Button>
									</NavLink>
								</Grid>
								<CheckPrint checkNo={chkno} branchidno={useridNo} onFetchedApi={onFetchedApi}/>
							</Grid>
						);
					} else if (checkstatus === "Approved" && printed === "Yes") {
						return (
							<Grid container spacing={1}>
								<Grid item xs={12} md={6} lg={12} xl={12}>
									<NavLink to={"/account/check-view-reference/" + chkno + "/" + useridNo}> {/*Check View Reference */}
										<Button variant="contained" color="primary">
											View
										</Button>
									</NavLink>
								</Grid>
								{cleared === "No" ?
									(
										<Grid item xs={12} d={6} lg={12} xl={12}>
											{get_cookies('can_process') == 1 ?
												<NavLink to={"/account/check-clear-view/" + chkno + "/" + useridNo}> {/*Check View Reference */}
													<Button variant="contained" color="primary">
														Clear
													</Button>
												</NavLink>
												: null}
										</Grid>
									) :
									(
										<></>
									)}
							</Grid>
						);
					} else {
						return (
							// <Grid container spacing={1}>
							// 	<Grid item xs={12} lg={6} xl={5}>
							// 		<NavLink to={"/account/check-view/" + chkno + "/" + useridNo}> {/*Check View*/}
							// 			<Button variant="contained" color="primary">
							// 				View
							// 			</Button>
							// 		</NavLink>
							// 	</Grid>
							// </Grid>
							<Grid container spacing={1}>
							<Grid item xs={12} md={6} lg={12} xl={12}>
							{get_cookies('can_edit') == 1 ?
								<NavLink to={"/account/check-edit/"+chkno+"/"+useridNo}>
									<Button variant="contained" color="primary">
										Edit
									</Button>	
								   </NavLink> 
								   :null}
							</Grid>
							<Grid item xs={12} md={6} lg={12} xl={12}>
									<NavLink to={"/account/check-view/" + chkno + "/" + useridNo}> {/*Check View*/}
										<Button variant="contained" color="primary">
											View
										</Button>
									</NavLink>
								</Grid>
						</Grid>
						);
					}
				},
				download: false //exclude this column in csv export
			}
		},
	];

	const style = {
		marginBottom: '1rem',
		marginTop: "2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/account">
						<h2 className="header-title">Accounts</h2>
					</NavLink>
					<Typography color="textPrimary">Check Transaction History</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
							<TextField
								id="outlined-basic"
								label="Select Date"
								variant="outlined"
								onFocus={() => setOpen(true)}
								fullWidth={true}
								autoComplete="off"
								value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
									dateRange.endDate,
									"MM/dd/yyyy"
								)}`}
							/>
							<DateRangePicker
								open={open}
								toggle={toggle}
								onChange={(range) => dateRangeHandler(range)}
							/>
						</Grid>
						<Grid item xs={1} lg={1} xl={1}>
							<Button
								variant="contained"
								style={{ marginTop: "23px" }}
								color="primary"
								onClick={onFetchedApi}
							>
								Search
							</Button>
						</Grid>
					</Grid>
				</div>
				{typeof (posts) !== null &&
					<DynamicTable
						title="Check Transaction history"
						columns={columns}
						rows={posts}
						setRows={setPosts}
						ref={refDataFilter}
						dateRange={dateRange}
						url="get_checks_trans_history"
					/>
				}
			</div>
		</div>
	);
};

export default CheckTransactionHistory;
